import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import { getWeekSpan } from 'lib/helper'

import DatePicker from 'material-ui/DatePicker'
import TimeslotWeeklyView from 'components/TimeslotWeeklyView'
import Button from 'material-ui/FlatButton'
import StatusDisplay from 'components/StatusDisplay'
import ShowHide from 'components/ShowHide'
import ColorCodeExplanation from 'components/ColorCodeExplanation'
import FontAwesome from 'react-fontawesome'

class AppointmentControlScreen extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      dateTimeFormat: global.Intl ? global.Intl.DateTimeFormat : {},
      startDate: props.minDate,
      weekSpan: '',
    }
    this.openDatePicker = this.openDatePicker.bind(this)
    this.onDaySelect = this.onDaySelect.bind(this)
    this.updateWeekSpan = this.updateWeekSpan.bind(this)
  }

  // Start with today
  UNSAFE_componentWillMount() {
    this.updateWeekSpan(this.props.minDate)
  }

  openDatePicker() {
    this.refs.datepicker.openDialog()
  }

  onDaySelect(e, date) {
    this.updateWeekSpan(date)
  }
  updateWeekSpan(date) {
    const { start, end, startDate } = getWeekSpan(date)
    this.setState({ startDate, weekSpan: `${start} até ${end}` })
    const { onLoadAppointments } = this.props
    onLoadAppointments(startDate)
  }

  render() {
    const { appointments, minDate, maxDate, onAppointmentCreateForDay, onAppointmentClose, onAppointmentOpen, onAppointmentStart, onAppointmentComplete, onAppointmentCancel, onAppointmentCloseAllForDay, onRefresh, ui } = this.props
    const { dateTimeFormat, startDate, weekSpan } = this.state

    return (
      <div className="AppointmentControlScreen">

        <StatusDisplay status={ui.agendaWeekAppointments}>
          Houve um erro ao carregar os horários da semana. Por favor tente novamente.
        </StatusDisplay>

        <ShowHide show={!ui.agendaWeekAppointments.isLoading}>
          <div className="AppointmentControlScreen_Header">

            <div className="AppointmentControlScreen_Controls">
              <TimePeriodDisplay
                startDate={startDate}
                weekSpan={weekSpan}
              />
              <Button
                label="Selecionar Semana"
                onClick={this.openDatePicker}
                primary
              />
              <FontAwesome name="refresh" size="lg" onClick={onRefresh} />
            </div>

            {/* Color codes */}
            <ColorCodeExplanation />

            <DatePicker ref="datepicker"
              className="DatePicker"
              autoOk hideCalendarDate
              locale="pt-br"
              disableYearSelection
              hintText="Selecione uma Data"
              minDate={minDate}
              maxDate={maxDate}
              DateTimeFormat={dateTimeFormat}
              onChange={this.onDaySelect}
            />
          </div>

          <TimeslotWeeklyView
            startDate={startDate}
            appointments={appointments}
            onAppointmentClose={onAppointmentClose}
            onAppointmentOpen={onAppointmentOpen}
            onAppointmentStart={onAppointmentStart}
            onAppointmentComplete={onAppointmentComplete}
            onAppointmentCancel={onAppointmentCancel}
            onAppointmentCreateForDay={onAppointmentCreateForDay}
            onAppointmentCloseAllForDay={onAppointmentCloseAllForDay}
            ui={ui}
          />
        </ShowHide>

      </div>
    )
  }
}
AppointmentControlScreen.propTypes = {
  appointments: PropTypes.array.isRequired,
  minDate: PropTypes.object.isRequired,
  maxDate: PropTypes.object.isRequired,
  onLoadAppointments: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onAppointmentClose: PropTypes.func.isRequired,
  onAppointmentOpen: PropTypes.func.isRequired,
  onAppointmentStart: PropTypes.func.isRequired,
  onAppointmentComplete: PropTypes.func.isRequired,
  onAppointmentCancel: PropTypes.func.isRequired,
  onAppointmentCreateForDay: PropTypes.func.isRequired,
  onAppointmentCloseAllForDay: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}

const TimePeriodDisplay = ({ startDate, weekSpan }) => {
  return (
    startDate ? <span className="TimePeriodDisplay"><strong>Período:</strong> <em>{weekSpan}</em></span> : null
  )
}

export default AppointmentControlScreen



// WEBPACK FOOTER //
// ./src/components/_Screens/AppointmentControl/index.js